module.exports = __webpack_public_path__ + "img/cloth_g1_hat_08.90ce303f.svg";